import {
  addDays,
  addMinutes,
  format,
  isAfter,
  isBefore,
  isEqual,
  isFriday,
  isMonday,
  isSaturday,
  isSunday,
  isThursday,
  isTuesday,
  isWednesday,
  parse,
  parseISO
} from "date-fns";

const parseDate = (dateString) => {
  return parse(dateString, 'dd/MM/yyyy', new Date());
}

export class BookingTimeModel {

  _day = null;

  constructor(from, to, openingTimes, openingHours, today, schedule, overrideOpeningTime, overrideClosingTime, /*today, date, hour, minute, openingTimes, schedule*/) {
    this._openingTimes = openingTimes;
    this._openingHours = openingHours;
    this._schedule = schedule;
    this._overrideOpeningTime = overrideOpeningTime;
    this._overrideClosingTime = overrideClosingTime;
    this.buildMainSchedule(from, to, today);
  }

  buildMainSchedule(from, to, today) {
    const schedule = {};
    for (var date = from; isBefore(date, to) | isEqual(date, to); date = addDays(date, 1)) {
      const dateKey = format(date, 'dd/MM/yyyy');
      //  date is not in the secondary schedule, so take it out of here
      if (this._schedule && !this._schedule[dateKey]) {
        continue;
      }
      const openingTimes = this.getOpeningTimes(date);

      var isOpen = openingTimes.IsOpen;
      if (this._openingHours) {
        this._openingHours.forEach((openingHour, oHindex) => {
          if(openingHour.specialOpeningHours) {
            openingHour.days.forEach((day, dIndex) => {
              const startTime = new Date(day.startTime);
              const endTime = new Date(day.endTime);
              if (startTime.getMonth() == date.getMonth() && startTime.getDate() == date.getDate()) {
                isOpen = !day.closed;
              }
            });
          }
        });
      }

      if (isOpen) {
        schedule[dateKey] = this.getTimeSlotValues(today, date);
        if (this._day == null && schedule[dateKey].length > 0) {
          this._day = dateKey;
          if (schedule[this._day].includes('19:00') && (!this._schedule || this._schedule[this._day].includes('19:00')))
            this._time = '19:00'
          else
            this._time = this._schedule ? this._schedule[this._day][0] : schedule[this._day][0];
        }
      }
    }

    this._mainSchedule = schedule;
  }

  select(dayString, time) {
    const day = parseDate(dayString);

    for (const scheduleDayString in this._mainSchedule) {
      const scheduleDay = parseDate(scheduleDayString);

      if (this._mainSchedule[scheduleDayString].length > 0) {
        if (isEqual(day, scheduleDay) || isAfter(scheduleDay, day)) {
          //
          //  this is a day we are interested in
          this._day = scheduleDayString;
          if (this._mainSchedule[scheduleDayString].includes(time) && (!this._schedule || this._schedule[this._day].includes(time))) {
            this._time = time;
            return;
          }
          else {
            this._time = this._schedule ? this._schedule[this._day][0] : this._mainSchedule[this._day][0];
            return
          }
        }
      }
    }
  }

  get day() {
    return this._day;
  }

  get date() {
    return parseDate(this._day);
  }

  get time() {
    return this._time;
  }

  get mainSchedule() {
    return this._mainSchedule;
  }

  mergeTimeWithDate(date, time) {
    const timeParts = time.split(':');
    return this.toISODateString(new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), parseInt(timeParts[0]), parseInt(timeParts[1]))));
  }

  toISODateString(date) {
    return date.toISOString().split('.')[0] + 'Z';
  }

  getOpeningTimes(date) {

    if (this._overrideOpeningTime && this._overrideClosingTime) {
      return {
        IsOpen: true,
        Open: this.mergeTimeWithDate(date, this._overrideOpeningTime),
        Closed: this.mergeTimeWithDate(date, this._overrideClosingTime)
      };
    }

    if (isMonday(date)) return this._openingTimes.Monday;
    if (isTuesday(date)) return this._openingTimes.Tuesday;
    if (isWednesday(date)) return this._openingTimes.Wednesday;
    if (isThursday(date)) return this._openingTimes.Thursday;
    if (isFriday(date)) return this._openingTimes.Friday;
    if (isSaturday(date)) return this._openingTimes.Saturday;
    if (isSunday(date)) return this._openingTimes.Sunday;
  }

  /**
   * Gets the timeslots for the current day
   * @returns 
   */
  getTimeSlots(today, date) {
    const dayOpeningTimes = this.getOpeningTimes(date);
    let open = parseISO(dayOpeningTimes.Open);
    let closed = parseISO(dayOpeningTimes.Closed);
    const timeSlots = [];
    //  strip the date to make it a "time only"
    open = new Date(date.getFullYear(), date.getMonth(), date.getDate(), open.getUTCHours(), open.getUTCMinutes());
    closed = new Date(date.getFullYear(), date.getMonth(), date.getDate(), closed.getUTCHours(), closed.getUTCMinutes());

    if (this._openingHours) {
      this._openingHours.forEach((openingHour, oHindex) => {
        if(openingHour.specialOpeningHours) {
          openingHour.days.forEach((day, dIndex) => {
            const startTime = new Date(day.startTime);
            const endTime = new Date(day.endTime);
            if (startTime.getMonth() == date.getMonth() && startTime.getDate() == date.getDate()) {
              open = new Date(date.getFullYear(), date.getMonth(), date.getDate(), startTime.getUTCHours(), startTime.getUTCMinutes());
              closed = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endTime.getUTCHours(), endTime.getUTCMinutes());
            }
          });
        }
      });
    }

    for (var timeSlot = open;
      isBefore(timeSlot, closed) || isEqual(timeSlot, closed);
      timeSlot = addMinutes(timeSlot, 15)) {
      if (timeSlot > today) {
        timeSlots.push(timeSlot);
      }
    }

    return timeSlots;
  }

  getTimeSlotValues(today, date) {
    return this.getTimeSlots(today, date).map(ts => format(ts, 'HH:mm'));
  }

  getHours(today, date) {
    const hours = [];
    this.getTimeSlots(today, date).forEach(ts => {
      const hour = format(ts, 'HH');
      if (!hours.includes(hour)) hours.push(hour);
    });
    return hours;
  }

  getMinutes(today, date, hour) {
    const minutes = [];
    this.getTimeSlots(today, date).forEach(ts => {
      const timeSlotHour = parseInt(format(ts, 'HH'));
      if (hour === timeSlotHour) {
        const minute = format(ts, 'mm');
        if (!minutes.includes(minute)) minutes.push(minute);
      }
    });
    return minutes;
  }

}